import { parseArrayEntry } from './parse-array-entry.js';
import { removeEmptyEntry } from './remove-empty-entry.js';

const compose = (...fns) => (arg, ...restArgs) => fns.reduceRight((acc, func) => func(acc, ...restArgs), arg);
function normalizeQuery(query = {}) {
  const reducer = compose(removeEmptyEntry, parseArrayEntry);
  return Object.entries(query).reduce((acc, entry) => reducer(acc, entry), query);
}

export { normalizeQuery };
